import React from "react";
import { useState, useEffect } from "react";
import TopHeader from "../../Components/TopHeader";
import Prince from "../../Components/Prince";
import { DateRangePicker } from "react-date-range";
import { format } from "date-fns";
import spiner from "../../../src/assets/img/spiner.gif";
import { MdDateRange } from "react-icons/md";
//import FilterComponent from "../Reports/ReportComponent/FilterComponent";
import CardComponent from "../Reports/ReportComponent/CardComponent";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Select from "@mui/joy/Select";
import Option from "@mui/joy/Option";
import { toast } from "react-toastify";
import SalesPersonFilter from "./SalesPersonFilter";
import ExportButton from "../../Components/ExportButton";

function SalesPersonPerformance({}) {
  const apiUrl = process.env.REACT_APP_URL;
  const Token = localStorage.getItem("_ux98c_v1");

  const [dateFilterModalOPen, setDateFilterModalOpen] = useState(false);
  const [modelOpen, setModalOpen] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState([]);
  const [leadSourceOptions, setLeadSourceOptions] = useState([]);
  const [employeeId, setEmployeeId] = useState([]);
  const [state, setStates] = useState([]);
  const [leadStatus, setLeadStatus] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [counts, setCounts] = useState([]);
  const [shipmentPotentialOptions, setShipmentPotentialOptions] = useState([]);
  const [performance, setPerformance] = useState([]);
  const [search, setSearch] = useState("");

  const [date, setDate] = useState(null);

  function formatTimestamp(timestamp) {
    const date = new Date(timestamp);

    const options = {
      weekday: "long", // e.g., Saturday
      year: "numeric",
      month: "long", // e.g., June
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true, // for AM/PM format
    };

    return date.toLocaleString("en-US", options);
  }

  const onFilterChange = (data) => {
    setFilterData(data);
  };

  const handleApplyFilter = () => {
    fetchData();
  };

  const handleDateFilterClick = () => {
    setDateFilterModalOpen(true);
  };
  const handleCloseDateFilterModal = () => {
    setDateFilterModalOpen(false);
  };

  const handleDateChange1 = (ranges) => {
    const adjustedStartDate = new Date(ranges.selection.startDate);
    adjustedStartDate.setUTCDate(adjustedStartDate.getUTCDate() + 1); // Subtract one day
    adjustedStartDate.setUTCHours(0, 0, 0, 0); // Set time to 00:00:00 UTC

    const adjustedEndDate = new Date(ranges.selection.endDate);
    adjustedEndDate.setUTCDate(adjustedEndDate.getUTCDate() + 1); // Add one day
    adjustedEndDate.setUTCHours(0, 0, 0, 0); // Set time to 00:00:00 UTC

    setFrom(adjustedStartDate.toISOString()); // Convert to UTC string format
    setTo(adjustedEndDate.toISOString());
    setDate(ranges.selection);

    if (
      ranges.selection.startDate &&
      ranges.selection.endDate &&
      ranges.selection.startDate.getTime() !==
        ranges.selection.endDate.getTime()
    ) {
      handleCloseDateFilterModal(); // close modal
    }
  };

  // useEffect(() => {
  const fetchData = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      };
      const response = await fetch(
        `${apiUrl}/salesPersonReport/salesPerformanceReport?from=${from}&to=${to}&search=${search}&shipmentPotential=${
          filterData.filterByPartner || ""
        }&employeeId=${filterData.filterByLeadSource || ""}&kycStatus=${
          filterData.filterByBusinessCategory || ""
        }&state=${filterData.filterByLeadPipeline || ""}`,
        {
          method: "GET",
          headers: headers,
        }
      );
      const result = await response.json();
      setPerformance(result.data);
    } catch (err) {
      toast.error(err.message);
    }
  };
  //   fetchData();
  // }, [filterData]);

  useEffect(() => {
    fetchData();
  }, [search]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        };
        const response = await fetch(
          `${apiUrl}/salesPersonReport/headerCount`,
          {
            method: "GET",
            headers: headers,
          }
        );
        const result = await response.json();
        setCounts(result.data);
      } catch (err) {
        toast.error(err.message);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/1`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setLeadSourceOptions(data.data);
        }
      });

    fetch(`${apiUrl}/employee/allStates/101`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setStates(data.data);
        }
      })
      .catch((error) => {
        // console.error("Error fetching gender options:", error);
      });
  }, []);

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/8`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setLeadStatus(data.data);
        }
      });
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/employee/empDropdownSub`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setEmployeeId(data.data);
        }
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/master/getAllMasterData/4`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setShipmentPotentialOptions(data.data);
        }
      })
      .catch((error) => {});
  }, []);
  // console.log(counts.totalOrder);
  // console.log(employeeId);
  return (
    <>
      <div className="page">
        <TopHeader />
        <Prince />
        <div className="main-content side-content pt-0 m-0">
          <div className="main-container container-fluid">
            <div className="inner-body">
              <div className="page-header my-2">
                <div>
                  <h2 className="main-content-title tx-24 mb-0 mt-1 ">
                    Sales Person Performance
                  </h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a>Report</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Sales Person Performance
                    </li>
                  </ol>
                </div>
              </div>
              <div style={{ marginTop: "15px" }}>
                <div className="row">
                  <CardComponent
                    title={"Total Customer"}
                    link={"Total Customer"}
                    count={counts.totalCustomer}
                  />
                  <CardComponent
                    title={"Total Order"}
                    link={"Total Order"}
                    // count={counts.totalOrder}
                    count={"45"}
                  />
                  <CardComponent
                    title={"Total Shipment"}
                    link={"Total Shipment"}
                    //count={counts.totalShipment}
                    count={"30"}
                  />
                  <CardComponent
                    title={"KYC Approved"}
                    link={"KYC Approved"}
                    count={counts.kycApproved}
                  />
                  <CardComponent
                    title={"KYC Pending"}
                    link={"KYC Pending"}
                    count={counts.kycPending}
                  />
                  <div className="card custom-card">
                    <div className="card-body py-0 pb-3">
                      <div className="row">
                        <div className="col-md-2 mt-3">
                          <label>Search Here</label>
                          <input
                            type="search"
                            className="form-control"
                            placeholder="Company Id , Email"
                            aria-controls="example1"
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                            style={{
                              border: "1px Solid #8E3E63",
                              // width: "300px",
                            }}
                          />
                        </div>
                        <div className="col-sm-2 mt-3">
                          <label>Date Filter</label>

                          <div>
                            <button
                              className="calender btn btn-outline-danger"
                              onClick={handleDateFilterClick}
                              style={{
                                fontSize: "11px",
                                // width: "215px",
                              }}
                            >
                              <MdDateRange
                                size={16}
                                style={{ display: "inline" }}
                              />{" "}
                              {date
                                ? `${format(
                                    date.startDate,
                                    "MMM dd yyyy"
                                  )} -- ${format(date.endDate, "MMM dd yyyy")}`
                                : "Select Calender Date"}
                            </button>
                          </div>

                          <div
                            className={`modal ${
                              dateFilterModalOPen ? "show" : ""
                            } bg-black-7`}
                            style={{
                              display: dateFilterModalOPen ? "block" : "none",
                            }}
                            tabIndex="-1"
                            role="dialog"
                          >
                            <div
                              className=" modal-dialog modal-dialog modal-lg"
                              role="document"
                              style={{ marginTop: "80px" }}
                            >
                              <div
                                className="modal-content"
                                style={{ borderRadius: "8px" }}
                              >
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    Select Date Range
                                  </h5>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={handleCloseDateFilterModal}
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div
                                  className="modal-body"
                                  style={{ width: "100%" }}
                                >
                                  <DateRangePicker
                                    // ranges={[date]}
                                    ranges={
                                      date
                                        ? [date]
                                        : [
                                            {
                                              startDate: new Date(),
                                              endDate: new Date(),
                                              key: "selection",
                                            },
                                          ]
                                    }
                                    onChange={handleDateChange1}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <SalesPersonFilter
                          leadSourceOptions={employeeId}
                          leadPipelineOptions={state}
                          businessCategoryOptions={[
                            { id: "Approved", name: "Approved" },
                            { id: "Pending", name: "Pending" },
                          ]}
                          partnerOptions={shipmentPotentialOptions}
                          onFilterChange={onFilterChange}
                        />
                        <div className="d-flex">
                          <div className="mr-2">
                            <button
                              style={{ marginTop: "30px" }}
                              className="btn btn-outline-success"
                              onClick={handleApplyFilter}
                            >
                              Apply Filter
                            </button>
                          </div>
                          <div className="mx-2">
                            <button
                              style={{ marginTop: "30px" }}
                              className="btn btn-outline-warning"
                              onClick={() => {
                                setDate({
                                  startDate: new Date(),
                                  endDate: new Date(),
                                  key: "selection",
                                });
                                window.location.reload();
                              }}
                            >
                              Clear Filter
                            </button>
                          </div>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="card custom-card">
                      <div className="card-body">
                        {/* <h5 style={{ textDecoration: "underline" }}>
                          Won Lead By Lead Source
                        </h5> */}

                        <div
                          class="table-responsive"
                          style={{ overflowY: "auto", height: "600px" }}
                        >
                          <table class="table table-hover table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th scope="col">Customer ID</th>
                                <th scope="col">Closure & Shipment</th>
                                <th scope="col">Client Information</th>
                                <th scope="col">Performance Metrics</th>
                                <th scope="col">Shipment Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {performance.map((item, index) => (
                                <tr key={index}>
                                  <td data-label="Email" class="email-cell">
                                    <p class="info">
                                      <strong>Customer ID : </strong> {item.id}
                                    </p>
                                  </td>
                                  <td data-label="Email" class="email-cell">
                                    <p class="info">
                                      <strong>Customer Name : </strong>{" "}
                                      {item.primaryContactName}
                                    </p>
                                    <p class="info">
                                      <strong>Company Name : </strong>{" "}
                                      {item.companyName}
                                    </p>
                                    <p class="info">
                                      <strong>Company Id : </strong>{" "}
                                      {item.companyId}
                                    </p>
                                    <p class="info">
                                      <strong>Email</strong>{" "}
                                      {item.employee.email}
                                      {""}
                                    </p>
                                    <p class="info">
                                      <strong>
                                        Total Order Synced(Life Time) :{" "}
                                      </strong>{" "}
                                      {item.performance.lifetimeOrders}
                                    </p>
                                    <p class="info">
                                      <strong>
                                        Total Shipment(Life Time):{" "}
                                      </strong>{" "}
                                      {item.performance.lifetimeShipments}
                                    </p>
                                    <p class="info">
                                      <strong>
                                        Total Order Synced(Current month) :{" "}
                                      </strong>{" "}
                                      {item.performance.currentOrders}
                                    </p>
                                    <p class="info">
                                      <strong>
                                        Total Shipment(Current Month):{" "}
                                      </strong>{" "}
                                      {item.performance.currentShipments}
                                    </p>
                                    <p class="info">
                                      <strong>
                                        Total Prepaid Percentage:{" "}
                                      </strong>{" "}
                                      {item.performance.weightDisrepancy}
                                    </p>
                                  </td>
                                  <td data-label="Email" class="email-cell">
                                    <p class="info">
                                      <strong>Total Cod Percentage: </strong>{" "}
                                      {item.performance.lifetimeCodPercentage}
                                      (%)
                                    </p>
                                    <p class="info">
                                      <strong>
                                        Client's Wallet Balance : ₹{" "}
                                        {item.externalWalletBalance || 0}
                                      </strong>{" "}
                                    </p>
                                    <p class="info">
                                      <strong>KYC Status : </strong>{" "}
                                      {item.externalkycStatus}
                                    </p>
                                    <p class="info">
                                      <strong>Account Closure Date : </strong>{" "}
                                      {""}
                                      {formatTimestamp(
                                        item.externalAccountClosureDate
                                      )}
                                    </p>
                                    <p class="info">
                                      <strong>Current KAM : </strong> {item.kam}
                                    </p>
                                    <p class="info">
                                      <strong>KAM Tier : </strong>
                                      {item.employee.kamType}
                                      {""}
                                    </p>
                                  </td>
                                  <td data-label="Email" class="email-cell">
                                    <p class="info">
                                      <strong>Delivery (%) : </strong>
                                      {
                                        item.performance
                                          .currentDeliveryPercentage
                                      }
                                      (%)
                                    </p>
                                    <p class="info">
                                      <strong>
                                        First Attempt Delivery (%) :{" "}
                                      </strong>{" "}
                                      {
                                        item.performance
                                          .currentFirstAttemptPercentage
                                      }
                                      (%)
                                      {""}
                                    </p>
                                    <p class="info">
                                      <strong>RTO (%) : </strong> {""}
                                      {item.performance.currentRtoPercentage}(%)
                                    </p>
                                    <p class="info">
                                      <strong>NDR (%) : </strong> {""}
                                      {item.performance.currentNdrPercentage}(%)
                                    </p>
                                    <p class="info">
                                      <strong> Intrasit Shipments : </strong>{" "}
                                      {""}
                                      {
                                        item.performance
                                          .currentIntransitPercentage
                                      }
                                      (%)
                                    </p>
                                    <p class="info">
                                      <strong>
                                        Total Prepaid Percentage :{" "}
                                      </strong>{" "}
                                      {""}
                                      {
                                        item.performance
                                          .lifetimePrePaidPercentage
                                      }
                                      (%)
                                    </p>
                                  </td>
                                  <td data-label="Email" class="email-cell">
                                    <p class="info">
                                      <strong>First Shipment Date : </strong>{" "}
                                      {formatTimestamp(
                                        item.externalfirstShipmentDate
                                      )}
                                    </p>
                                    <p class="info">
                                      <strong>Last Shipemnt Date : </strong>{" "}
                                      {formatTimestamp(
                                        item.externallastShipmentDate
                                      )}
                                    </p>
                                    <p class="info">
                                      <strong>
                                        Shipments Volume Growth :{" "}
                                      </strong>{" "}
                                      {item.performance.shipmentGrowth}(%) {""}
                                    </p>
                                    <p class="info">
                                      <strong>Growth Status : </strong> {""}
                                      {item.performance.growthStatus} {""}
                                    </p>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2 mb-2"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ExportButton
                            reportUrl={`${apiUrl}/salesPersonReport/salesPerformanceReportExcel`}
                            // filterState={filterData}
                            fileName="OpenLeads_Jan.csv"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Row */}
              </div>

              {}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SalesPersonPerformance;
